import React, { useState, useMemo } from 'react';
import MUIDataTable from 'mui-datatables';

import CustomToolbar from 'components/CustomToolbar/CustomToolbar';

import { standard } from 'constants/userAccountTypes';

const ProductsTable = (props) => {

  const [rowsSelected, setRowsSelected] = useState([]);

  const tableData = useMemo(() => {
    const initialTableData = [];

    for ( let i = 0; i < props.products.length; i++ ) {
      const product = props.products[i];
      initialTableData.push({
        id: product.id,
        displayId: product.displayId,
        name: product.name,
        category: product.category,
        company: product.company,
        barcode: product.barcode
      });
    }

    return initialTableData;

  }, [props.products]);

  const columns = [
    { label: "ID", name: "displayId" },
    { label: "Name", name: "name"},
    { label: "Category", name: "category" },
    { label: "Company", name: "company" }
  ];

  const onRowSelectionChange = (curr, all, rowsSelected) => {
    setRowsSelected(rowsSelected);

    if(rowsSelected.length === 1) {
      const productInfo = tableData[rowsSelected[0]];
      props.setUpdateInfo({
        id: productInfo.id,
        name: productInfo.name,
        category: productInfo.category,
        company: productInfo.company,
        barcode: productInfo.barcode
      });
    }
  };

  const customToolbarSelect = () => {
    return (
      <CustomToolbar
        switchy={1}
        element="Product"
        setUpdate={props.updateProduct}
      />
    )
  };
  
  const standardOptions = {
    filterType: 'checkbox',
    selectableRows: 'none'
  };
  
  const adminOptions = {
    filterType: 'checkbox',
    selectableRows: 'single',
    selectableRowsOnClick: true,
    rowsSelected,
    onRowSelectionChange,
    customToolbarSelect
  };

  return (
    <MUIDataTable 
      title={"Product List"}
      data={tableData}
      columns={columns}
      options={props.activeUserType === standard ? standardOptions : adminOptions}
    />
  )
};

export default ProductsTable;